import { inherits as _inherits, createClass as _createClass, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { getPageSize } from '../utils/pageSize.js';
import { WindowHelperWrapper } from '../utils/WindowHelper.js';
import { PaginationComponent } from './PaginationComponent.js';
var BUTTON_BREAKPOINTS = [480, 768, 1024];
var DEFAULT_BUTTON_COUNTS = [0, 1, 2, 3];
var getPagingInfo = function getPagingInfo(props) {
  var totalCount = props.totalCount || 0;
  var dataSize = props.data && props.data.length || 0;
  var hasPagination = totalCount > dataSize;
  var pageSize = props.pageSize || getPageSize();
  var pageCount = Math.ceil(totalCount / pageSize);
  var activePage = props.activePage;
  return {
    totalCount: totalCount,
    dataSize: dataSize,
    hasPagination: hasPagination,
    pageSize: pageSize,
    pageCount: pageCount,
    activePage: activePage
  };
};
var Pagination = /*#__PURE__*/function (_React$Component) {
  function Pagination(props) {
    var _this;
    _classCallCheck(this, Pagination);
    _this = _callSuper(this, Pagination, [props]);
    _defineProperty(_this, "onButtonCountChange", function (index) {
      _this.setState({
        defaultButtonCount: DEFAULT_BUTTON_COUNTS[index]
      });
    });
    _defineProperty(_this, "handleSelect", function (eventKey) {
      _this.setState({
        activePage: eventKey
      });
      _this.props.onPageChange(eventKey);
    });
    _defineProperty(_this, "hasPagination", function () {
      var totalCount = _this.props.totalCount || 0;
      var dataSize = _this.props.data && _this.props.data.length || 0;
      return totalCount > dataSize;
    });
    _this.windowHelper = WindowHelperWrapper(props.windowOverride);
    _this.state = {
      activePage: props.activePage || 1,
      defaultButtonCount: 9
    };
    return _this;
  }
  _inherits(Pagination, _React$Component);
  return _createClass(Pagination, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.destroyWindowWatcher = this.windowHelper.watchBreakpoints(BUTTON_BREAKPOINTS, this.onButtonCountChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyWindowWatcher();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!!this.props.activePage && this.props.activePage !== prevProps.activePage) {
        this.setState({
          activePage: this.props.activePage
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.isLoadingData) {
        return null;
      }
      var pagingInfo = getPagingInfo(this.props);
      if (!pagingInfo.hasPagination) {
        return null;
      }
      var siblingPagesRange = Math.max(0, this.props.maxButtons ? (this.props.maxButtons - 3) / 2 : this.state.defaultButtonCount);
      var currentPage = this.state.activePage > pagingInfo.pageCount ? pagingInfo.pageCount : this.state.activePage;
      return /*#__PURE__*/React.createElement(PaginationComponent, {
        currentPage: currentPage,
        totalPages: pagingInfo.pageCount,
        isBranded: this.props.isBranded,
        hideFirstAndLastPageLinks: true,
        siblingPagesRange: siblingPagesRange,
        onChange: this.handleSelect
      });
    }
  }]);
}(React.Component);
_defineProperty(Pagination, "propTypes", {
  activePage: PropTypes.number,
  data: PropTypes.array,
  isBranded: PropTypes.bool,
  isLoadingData: PropTypes.bool,
  maxButtons: PropTypes.number,
  onPageChange: PropTypes.func.isRequired,
  totalCount: PropTypes.number,
  windowOverride: PropTypes.object
});
Pagination.displayName = "Pagination";
export { Pagination, getPagingInfo };